module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gtWVN"))).then(() => parcelRequire('hEqeo'));